import {
  useZustandLanguagesKitStore,
  languageSelectors,
  useZustandModalKitStore,
  EModalTypes,
  zustandModalKitSelector,
  ArrowSvg,
} from 'react-gldn-kit';
import cln from 'classnames';

import { useZustandWebConfiguration } from 'stores/configuration/store';
import { getLanguagesInfoSelector } from 'stores/configuration/selectors';

import { getFlagIcon } from 'utils/icons';

import styles from './ButtonLanguage.module.css';

const ButtonLanguage = ({
  classes,
  isWithName = false,
  isWithArrow,
}: {
  classes?: string;
  isWithName?: boolean;
  isWithArrow?: boolean;
}) => {
  const languages = useZustandWebConfiguration(getLanguagesInfoSelector) || [];

  const activeLanguageName = useZustandLanguagesKitStore(
    languageSelectors.getActiveLanguageNameKitSelector
  );

  const setModal = useZustandModalKitStore(
    zustandModalKitSelector.closeAndOpenModalAction
  );

  const activeLanguage = languages.find(
    (l) => l.shortName === activeLanguageName
  );

  const handleOpenPopUp = (e?: React.MouseEvent<HTMLDivElement>) => {
    e?.stopPropagation();
    e?.preventDefault();

    setModal(EModalTypes.Languages, {
      title: 'languages',
    });
  };

  return (
    <div
      className={cln(
        styles.wrapperButtonLanguage,
        {
          [styles.fullView]: isWithName,
        },
        classes
      )}
      onClick={handleOpenPopUp}
    >
      <div className={styles.row}>
        <div className={styles.icon}>
          {activeLanguageName ? getFlagIcon(activeLanguageName) : 'loading'}
        </div>
        {isWithName && <div>{activeLanguage?.name}</div>}
      </div>

      {isWithArrow && (
        <ArrowSvg classes={styles.arrowSvg} width={16} height={9} />
      )}
    </div>
  );
};

export default ButtonLanguage;
